import { Injectable }     from '@angular/core';
import { Http, Response } from '@angular/http';
import { Headers, RequestOptions } from '@angular/http';

import { Observable }     from '../../../node_modules/rxjs/Observable';
import { Product } from '../entities/product';
import { Customer } from '../entities/customer';

import { SERVER_URL } from './server-url';

@Injectable()   
export class ProductService {
    private productUrl = SERVER_URL + '/api/products';  // URL to web API
    //private trackerUrl = 'http://104.198.40.29:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://localhost:3005/api/delivery';  // URL to web API
    //private trackerUrl = 'http://192.168.15.8:3005/api/delivery';  // URL to web API
    
    public products:Array<Product>;

    constructor (private http: Http) {}

    getProducts(tokenLogged:string): Observable<Product[]> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('getProducts...');
        return this.http.get(this.productUrl, {headers: headers})
                    .map(this.extractProductsFromJSON)
                    .catch(this.handleError);
    }
    
    private extractProductsFromJSON(res: Response | any) {
        let body = res.json();
        var productsList:Product[] = []; 

        for (let entry of body) {
            if (!entry.id) { return; }
            var product:Product = new Product(entry.id, new Customer(entry.customer_id, null, null, null, null), entry.name, entry.weight, entry.quantity, entry.price);
            product.idExternal = (entry.id_external && entry.id_external.length > 0) ? entry.id_external : null;
            productsList.push(product);
        }
        //console.log(productsList);
        return productsList;
    }   

    insertProduct(tokenLogged:string, product:Product): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.productUrl + '/insert', product, {headers: headers})
                    .map(this.resultInsert)
                    .catch(this.handleError);
    }

    private resultInsert(res: Response | any) {
        let body = res.json();
        //console.log("retorno insert => " + body);
    }

    updateProduct(tokenLogged:string, product:Product): Observable<any> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        
        return this.http.post(this.productUrl + '/update', product, {headers: headers})
                    .map(this.resultInsert)
                    .catch(this.handleError);
    }

    getProductById(tokenLogged:string, id:number): Observable<Product> {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.get(this.productUrl + '/' + id, {headers: headers})
                    .map(this.extractProductFromJSON)
                    .catch(this.handleError);
    }

    private extractProductFromJSON(res: Response | any) {
        let body = res.json();
        let entry = body[0];
        //console.log('entry -> ' + entry);

        if (!entry.id) { return; }

        var product:Product = new Product(entry.id, new Customer(entry.customer_id, null, null, null, null), entry.name, entry.weight, entry.quantity, entry.price);
        product.idExternal = (entry.id_external && entry.id_external.length > 0) ? entry.id_external : null;

        return product;
    }

    deleteProduct(tokenLogged:string, product:Product) {
        let headers = new Headers();
        headers.append('Authorization', 'JWT ' + tokenLogged);
        //console.log('chamando o serviço da services');
        return this.http.post(this.productUrl + '/deactivate', product, {headers: headers})
                    .map(this.deleteDriverExtractFromJSON)
                    .catch(this.handleError);
        
        
    }

    private deleteDriverExtractFromJSON(res: Response | any) {
        //console.log('Excluído');
        let body = res.json();
        let entry = body[0];
        //console.log('res -> ' + entry);

    }

    private handleError (error: Response | any) {
        let errMsg: string;

        if (error instanceof Response) {
            const body = error.json() || '';
            const err = body.error || JSON.stringify(body);
            
            //errMsg = `${error.status} - ${error.statusText || ''} ${err}`;
            errMsg = body.detail || 'Ocorreu um erro no servidor.';
        } 
        else {
            errMsg = error.message ? error.message : error.toString();
        }
        return Observable.throw(errMsg);
    }

    
}


// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader?keepUrl=true!./app/shared/services/product.service.ts